import { RefObject, useEffect, useState } from 'react';

export function useItemWidth(
  containerRef: RefObject<HTMLDivElement | null>,
  itemsToShow: number,
  gap: number
): number {
  const [itemWidth, setItemWidth] = useState(0);

  useEffect(() => {
    const updateItemWidth = (): void => {
      if (!containerRef.current) {
        return;
      }

      const containerWidth = containerRef.current.clientWidth;
      const newItemWidth = (containerWidth - (itemsToShow - 1) * gap) / itemsToShow;
      setItemWidth(newItemWidth);
    };

    updateItemWidth();
    window.addEventListener('resize', updateItemWidth);

    return () => {
      window.removeEventListener('resize', updateItemWidth);
    };
  }, [containerRef, itemsToShow, gap]);

  return itemWidth;
}
